export default {
  header: {
    home: "首页",
    product: "产品中心",
    about: "品牌介绍",
    blog: "媒体中心",
    contact: "联系我们",
    login: "登录",
    register: "注册",
    buyOnline: "在线购买"
  },
  hero: {
    subTitle: "阿森纳足球俱乐部",
    title: "官网全球合作伙伴",
    year: "未来三年 2023.12—2027.5",
    fans: "4亿粉丝 联通全球",
    cta: "了解更多"
  },
  company: {
    title: "集团简介",
    description: "中策橡胶集团致力于为社会创造价值，科技创新，追求安全、绿色、有价值的轮胎生产，为全球消费者带来更多产品和服务。",
    description2: "此外，中策橡胶集团积极参与可持续企业社会责任项目，并在全球范围内开展人文关怀公益活动。",
    cta: "了解更多"
  },
  stats: {
    foundedYear: "1958年",
    foundedDesc: "中策橡胶前身成立",
    revolutionYear: "2004年",
    revolutionDesc: "公牛轮胎诞生",
    pioneersTitle: "先行者",
    pioneersDesc: "汽车后市场行业数字化升级先锋",
    standardTitle: "标杆",
    standardDesc: "乘用车轮胎替换市场服务新标杆"
  },
  products: {
    title: "精选轮胎",
    popular: "畅销产品",
    description: "公牛GRT-comfort舒适型轮胎专为家用轿车设计，具有出色的舒适性、精准的操控性和静音性能。采用先进的胎面花纹设计，确保在各种路况下提供卓越的抓地力和稳定性，同时有效降低路噪，为驾驶者带来平稳舒适的驾乘体验。",
    buyNow: "立即购买",
    learnMore: "了解更多",
    series: {
      all: "全部"
    }
  },
  media: {
    title: "媒体中心",
    date: "2024-12-27",
    article1: {
      title: "天骥系统，突破性能边界，推动高质发展",
      description: "天骥乘用车轮胎技术系统于2024中策橡胶年中大会正式发布。而随着技术的不断深化，天骥系统也在进化得越来越强。这一新一代轮胎品牌自己的轮胎技术体系，其衍生的产品，也实现了性能的全面跃升。天骥系统并非行业传统的单一研发技术体系，而是基含了8大核心技术能力与12项关键技术的轮胎多维高性能研发平台，它包括针对噪音的静音槽技术、静音柱阵技术、消音胎技术；针对滚动阻力的混合动力配方2.0、温压分离优化技术、超高均匀性能制造技术；针对操控性的高弹胎体补强技术、BPOT胎冠自适应技术..."
    },
    article2: {
      title: "2024中策橡胶集团（中国区）年中经销商大会盛大召开",
      description: "2024年7月10日，2024中策橡胶集团（中国区）年中经销商大会在广东珠海如期召开，本次大会以\"正向聚能 高质创领——与时俱进 创造新优势\"为主题，汇集全国500余名经销商代表，回顾2024上半年的奋斗足迹，共谋下半年高质发展大计。大会伊始，中策橡胶董事长、总经理沈金荣作开幕致辞，他分析了国内外的市场环境，并表示中策将在困难中求得竞争优势。同时，沈总介绍了中策上半年的工作重心和收获，中策以科技创新为引领，天工商用车胎技..."
    },
    article3: {
      title: "中策橡胶携手欧洲经销商，共赴阿森纳赛事日VIP之旅",
      description: "4月13至14日，中策橡胶集团携手欧洲经销商们，共同踏上了一段难忘的旅程——阿森纳赛事日VIP之旅。这不仅是一场体育盛事，更是一次品牌与文化的深度交融。作为全球领先的轮胎制造商，中策橡胶自去年起便与阿森纳足球俱乐部结缘，成为其官方全球合作伙伴。而这次赛事日之旅，正是双方合作的一次精彩呈现。在这次难忘的旅程中，中策橡胶欧洲团队与经销商们，共同感受阿森纳足球俱乐部的独特魅力..."
    },
    readMore: "了解更多"
  },
  partners: {
    title: "中策橡胶合作伙伴",
    description: "我们提供由客户选择的流行轮胎，以最大限度地提高您在长途旅行中的舒适度。"
  },
  footer: {
    title: "帮助中心",
    product: "产品中心",
    productTitle: "产品",
    aboutTitle: "关于我们",
    about: "关于轮胎",
    blog: "博客",
    contact: "联系我们",
    qrcode: "二维码",
    wechat: "微信",
    tiktok: "抖音",
    description: "公牛轮胎的名字灵感源自自然界中力量与耐力、坚韧与强悍的象征——公牛，寓意着无论面对何种路况，都能如公牛般勇往直前，无畏挑战，稳健致远。",
    copyright: "©2024 版权所有 中策橡胶集团有限公司 | 浙ICP备 11018622-1 | 浙公网安备 33011802000703号"
  },
  common: {
    learnMore: '了解更多',
    loading: '加载中...',
    loadingProducts: '加载产品信息中...',
    loadingMedia: '加载媒体信息中...',
    retry: '重试',
    noProducts: "暂无产品",
    noProductData: '暂无产品数据',
    noProductId: '未指定产品ID',
    getProductDetailFailed: '获取产品详情失败，请稍后重试',
    noProductDescription: '暂无产品描述',
    buyNow: '去购买',
    noMedia: '暂无媒体信息',
    collapse: '收起',
    viewMore: '查看更多',
    lastPage: '末页',
    backToList: '返回列表',
    getArticleDetailFailed: '获取文章详情失败，请稍后重试',
    empty: "暂无内容",
    noQrcode: "暂无二维码"
  },
  home: {
    brandIntroTitle: '品牌简介',
    brandIntroText: '公牛轮胎（Bull Tire），中策橡胶集团股份有限公司旗下品牌，诞生于2004年，从中国更广泛消费者需求出发，背靠中策专利技术及研发实力，致力于通过优化材料及配方、提升制造工艺，打造出长里程、高稳定性、高安全性，更适合中国路况和车主的轮胎，让每一位车主都能享受到安全、舒适的驾驶体验。',
    groupIntroTitle: '集团简介',
    groupIntroText1: '中策橡胶集团致力于为社会创造价值，创新科学技术，追求生产安全、绿色、有价值的轮胎，为全球消费者带来更多的产品及服务选择。',
    groupIntroText2: '除此之外，中策橡胶集团积极参与可持续的企业社会责任项目，在全球范围内开展人文关怀的公益活动。'
  },
  about: {
    pageTitle: '品牌介绍',
    brandIntroTitle: '品牌简介',
    brandIntroText: '公牛轮胎（Bull Tire），中策橡胶集团股份有限公司旗下品牌，诞生于2004年，从中国更广泛消费者需求出发，背靠中策专利技术及研发实力，致力于通过优化材料及配方、提升制造工艺，打造出长里程、高稳定性、高安全性，更适合中国路况和车主的轮胎，让每一位车主都能享受到安全、舒适的驾驶体验。',
    groupIntroTitle: '集团简介',
    groupIntroText1: '中策橡胶集团致力于为社会创造价值，创新科学技术，追求生产安全、绿色、有价值的轮胎，为全球消费者带来更多的产品及服务选择。',
    groupIntroText2: '除此之外，中策橡胶集团积极参与可持续的企业社会责任项目，在全球范围内开展人文关怀的公益活动。',
    partnersTitle: '合作伙伴',
    achievementsTitle: '中策橡胶品牌成就',
    governmentAwardsTitle: '政府颁发荣誉',
    manufacturerAwardsTitle: '主流厂家奖',
    governmentAwards: {
      0: '2016年第二届浙江省工业大奖金奖',
      1: '2016年杭州十二五纳税百强企业',
      2: '2016年中国标准创新贡献奖',
      3: '2016年中国对外贸易500强企业',
      4: '2017年中国轮胎企业排行榜第一名',
      5: '2020年杭州市首批鲲鹏企业'
    },
    manufacturerAwards: {
      0: '2014年长安汽车优秀供应商奖',
      1: '2015年北汽福田优秀供应商奖',
      2: '2015年广西柳工优秀供应商奖',
      3: '2015年江淮汽车优秀供应商奖',
      4: '2015年上汽通用优秀绿色供应商奖',
      5: '2016年奇瑞捷豹路虎X260L最佳投产奖',
      6: '2017年江淮汽车优秀供应商奖',
      7: '2017年陕汽重卡优秀供应商奖',
      8: '2017年一汽解放优秀供应商奖'
    }
  },
  blog: {
    pageTitle: '媒体中心',
    lastPage: '末页',
    learnMore: '了解更多'
  }
}
